const baseLegTemplate = {
  idle: false,
  futOpt: 'OPT',
  strikeSelection: 'Distance',
  strikeValue: 0,
  expirySelection: 'Relative',
  baseQty: 1,
  qty: 1,
  oldQty: 1,
  onSlAction: 0,
  onSlReEntryCount: 0,
  onSlTargetStrategyId: "",
  rms: {
    basis: 0,
    stopLossInput: {
      valueType: 0,
      value: ""
    },
    takeProfitInput: {
      valueType: 0,
      value: ""
    },
    trailSL: {
      valueType: 2,
      reference: "",
      step: ""
    },
    profitLockAt: "",
    profitLockSl: "",
    profitLockTrail: {
      valueType: 2,
      reference: "",
      step: ""
    }
  },
  onTgtAction: 'Do Nothing'
};

export const getDefaultRelativeExpiry = (symbol) => {
  return symbol === 'NIFTY' || symbol === 'SENSEX' ? 'Current Weekly' : 'Current Monthly';
};

export const createLeg = (id, side, optionType, distance, qty, expiryRel) => ({
  id,
  ...baseLegTemplate,
  side,
  optionType,
  strikeValue: distance,
  qty: qty ?? 1,
  oldQty: qty ?? 1,
  expiry: expiryRel
});

export const buildTemplateLegs = (templateName, symbol) => {
  const curExpiry = getDefaultRelativeExpiry(symbol || '');

  switch (templateName) {
    case 'Buy Call':
      return [createLeg(1, 'BUY', 'CE', 0, 1, curExpiry)];

    case 'Sell Put':
      return [createLeg(1, 'SELL', 'PE', 0, 1, curExpiry)];

    case 'Bull Call Spread':
      return [
        createLeg(1, 'BUY', 'CE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 4, 1, curExpiry),
      ];

    case 'Bull Put Spread':
      return [
        createLeg(1, 'SELL', 'PE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', -4, 1, curExpiry),
      ];

    case 'Call Ratio Back Spread':
      return [
        createLeg(1, 'SELL', 'CE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'CE', 4, 2, curExpiry),
      ];

    case 'Long Calendar with Calls': {
      const nextExp = 'Next Monthly';
      return [
        createLeg(1, 'SELL', 'CE', 5, 1, curExpiry),
        createLeg(2, 'BUY', 'CE', 5, 1, nextExp),
      ];
    }

    case 'Bull Condor':
      return [
        createLeg(1, 'BUY', 'CE', 5, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 9, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 13, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 17, 1, curExpiry),
      ];

    case 'Bull Butterfly':
      return [
        createLeg(1, 'BUY', 'CE', 5, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 9, 2, curExpiry),
        createLeg(3, 'BUY', 'CE', 13, 1, curExpiry),
      ];

    case 'Range Forward':
      return [
        createLeg(1, 'BUY', 'CE', 4, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -8, 1, curExpiry),
      ];

    case 'Long Synthetic Future':
      return [
        createLeg(1, 'BUY', 'CE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', 0, 1, curExpiry),
      ];

    case 'Buy Put':
      return [createLeg(1, 'BUY', 'PE', 0, 1, curExpiry)];

    case 'Sell Call':
      return [createLeg(1, 'SELL', 'CE', 0, 1, curExpiry)];

    case 'Bear Call Spread':
      return [
        createLeg(1, 'SELL', 'CE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'CE', 4, 1, curExpiry),
      ];

    case 'Bear Put Spread':
      return [
        createLeg(1, 'BUY', 'PE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -4, 1, curExpiry),
      ];

    case 'Put Ratio Back Spread':
      return [
        createLeg(1, 'SELL', 'PE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', -4, 2, curExpiry),
      ];

    case 'Long Calendar with Puts': {
      const nextExp = 'Next Monthly';
      return [
        createLeg(1, 'SELL', 'PE', -5, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', -5, 1, nextExp),
      ];
    }

    case 'Bear Condor':
      return [
        createLeg(1, 'BUY', 'PE', -5, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -9, 1, curExpiry),
        createLeg(3, 'SELL', 'PE', -13, 1, curExpiry),
        createLeg(4, 'BUY', 'PE', -17, 1, curExpiry),
      ];

    case 'Bear Butterfly':
      return [
        createLeg(1, 'BUY', 'PE', -5, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -9, 2, curExpiry),
        createLeg(3, 'BUY', 'PE', -13, 1, curExpiry),
      ];

    case 'Risk Reversal':
      return [
        createLeg(1, 'SELL', 'CE', 4, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', -8, 1, curExpiry),
      ];

    case 'Short Synthetic Future':
      return [
        createLeg(1, 'SELL', 'CE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', 0, 1, curExpiry),
      ];

    case 'Short Straddle':
      return [
        createLeg(1, 'SELL', 'CE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', 0, 1, curExpiry),
      ];

    case 'Short Strangle':
      return [
        createLeg(1, 'SELL', 'CE', 4, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', 4, 1, curExpiry),
      ];

    case 'Iron Butterfly':
      return [
        createLeg(1, 'BUY', 'PE', -4, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', 0, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 0, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 4, 1, curExpiry),
      ];

    case 'Short Iron Condor':
      return [
        createLeg(1, 'BUY', 'PE', -8, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -4, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 4, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 8, 1, curExpiry),
      ];

    case 'Batman':
      return [
        createLeg(1, 'BUY', 'CE', 5, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 6, 2, curExpiry),
        createLeg(3, 'BUY', 'PE', -5, 1, curExpiry),
        createLeg(4, 'SELL', 'PE', -6, 2, curExpiry),
      ];

    case 'Double Plateau':
      return [
        createLeg(1, 'BUY', 'CE', 4, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 8, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 12, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 16, 1, curExpiry),
        createLeg(5, 'BUY', 'PE', -5, 1, curExpiry),
        createLeg(6, 'SELL', 'PE', -9, 1, curExpiry),
        createLeg(7, 'SELL', 'PE', -13, 1, curExpiry),
        createLeg(8, 'BUY', 'PE', -17, 1, curExpiry),
      ];

    case 'Jade Lizard':
      return [
        createLeg(1, 'SELL', 'PE', -4, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 10, 1, curExpiry),
        createLeg(3, 'BUY', 'CE', 13, 1, curExpiry),
      ];

    case 'Reverse Jade Lizard':
      return [
        createLeg(1, 'SELL', 'CE', 4, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -10, 1, curExpiry),
        createLeg(3, 'BUY', 'PE', -13, 1, curExpiry),
      ];

    case 'Call Ratio Spread':
      return [
        createLeg(1, 'BUY', 'CE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'CE', 4, 2, curExpiry),
      ];

    case 'Put Ratio Spread':
      return [
        createLeg(1, 'BUY', 'PE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -4, 2, curExpiry),
      ];

    case 'Long Straddle':
      return [
        createLeg(1, 'BUY', 'CE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'PE', 0, 1, curExpiry),
      ];

    case 'Long Iron Butterfly':
      return [
        createLeg(1, 'BUY', 'PE', 0, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -4, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 4, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 0, 1, curExpiry),
      ];

    case 'Long Strangle':
      return [
        createLeg(1, 'BUY', 'PE', -4, 1, curExpiry),
        createLeg(2, 'BUY', 'CE', 4, 1, curExpiry),
      ];

    case 'Long Iron Condor':
      return [
        createLeg(1, 'BUY', 'PE', -4, 1, curExpiry),
        createLeg(2, 'SELL', 'PE', -8, 1, curExpiry),
        createLeg(3, 'SELL', 'CE', 8, 1, curExpiry),
        createLeg(4, 'BUY', 'CE', 4, 1, curExpiry),
      ];

    case 'Strip':
      return [
        createLeg(1, 'BUY', 'PE', 0, 1, curExpiry),
        createLeg(2, 'BUY', 'CE', 0, 2, curExpiry),
      ];

    case 'Strap':
      return [
        createLeg(1, 'BUY', 'CE', 0, 2, curExpiry),
        createLeg(2, 'BUY', 'PE', 0, 1, curExpiry),
      ];

    default:
      return [];
  }
};
